import { DayHours, Bools } from '@models/day-hours.model';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RangeHourService {

  dayHours: DayHours[];

  constructor() { }

  setDayHours(dayHours: DayHours[]) {
    this.dayHours = dayHours;
  }

  setRangeHour(init, end) {
    // cogemos la hora de inicio y fin y las convertimos en algo que podamos buscar en nuesra array

    const startTime = init.substring(0, 5);
    const endTime = end.substring(0, 5);

    let i;
    // recorremos nuestra array
    for (i = 0; i < this.dayHours.length; i++) {

      // cuando la fecha de la array coincide con la hora de inicio metida
      if (this.dayHours[i].hour === startTime) {

        //  y la hora de inicio no esta pillada
        if (this.dayHours[i].bools.init === false) {
          // marcamos las dos como pilladas
          this.dayHours[i].bools.init = true;
          this.dayHours[i].bools.end = true;

          // aumentamos en 1 el contador para empezar a recorrer desde el item siguiente desde la hora de entrada
          i++;

          // y recorremos la array desde donde lo dejamos antes
          for ( i ; i < this.dayHours.length; i++) {

            // mientras la fecha recorrida sea distinta de la fecha de fin
            if (this.dayHours[i].hour !== endTime) {

              // y no este ya pillada
              if (this.dayHours[i].bools.init === false) {
                // marcamos como pillada
                this.dayHours[i].bools.init = true;
                this.dayHours[i].bools.end = true;
              } else {
                // si esta pilladda lanzamos un error
                return 'error';
              }
            } else {
              // cuando sea igual marcamos solo la hora de fin
              this.dayHours[i].bools.end = true;
              return false;
            }
          }
        } else {
          // si esta pillada lanzamos un error
          return 'error';
        }

      }

    }
  }

  deleteRangeHour(init: Date, end: Date) {
    // cogemos la hora de inicio y fin y las convertimos en algo que podamos buscar en nuesra array
    const startTime = this.numberToString(init.getHours()) + ':' + this.numberToString(init.getMinutes());
    const endTime = this.numberToString(end.getHours()) + ':' + this.numberToString(end.getMinutes());

    let i;
    // recorremos nuestra array
    for (i = 0; i < this.dayHours.length; i++) {

      // cuando la fecha de la array coincide con la hora de inicio metida
      if (this.dayHours[i].hour === startTime) {

        //  y la hora de inicio este pillada
        if (this.dayHours[i].bools.init === true) {
          // marcamos las dos libres
          this.dayHours[i].bools.init = false;
          this.dayHours[i].bools.end = false;

          // y recorremos la array desde donde lo dejamos antes
          for ( i ; i < this.dayHours.length; i++) {

            // mientras la fecha recorrida sea distinta de la fecha de fin
            if (this.dayHours[i].hour !== endTime) {

              // y este ya pillada
              if (this.dayHours[i].bools.init === true) {
                // marcamos como libre
                this.dayHours[i].bools.init = false;
                this.dayHours[i].bools.end = false;
              } else {
                // si esta pillada lanzamos un error
              }
            } else {
              // cuando sea igual marcamos solo la hora de fin
              this.dayHours[i].bools.end = false;
            }
          }
        } else {
          // si esta pilladda lanzamos un error
        }

      }

    }
  }

  numberToString(data) {
    if (data.toString().length === 1) {
      return '0' + data;
    } else {
      return data;
    }
  }

  resetDayHours() {
    this.dayHours = this.newArrayHours();
  }

  newArrayHours() {
    // array para hacer el reset
    const newHours: DayHours[] = [
      { hour: '00:00', bools: new Bools() },
      { hour: '00:30', bools: new Bools() },
      { hour: '01:00', bools: new Bools() },
      { hour: '01:30', bools: new Bools() },
      { hour: '02:00', bools: new Bools() },
      { hour: '02:30', bools: new Bools() },
      { hour: '03:00', bools: new Bools() },
      { hour: '03:30', bools: new Bools() },
      { hour: '04:00', bools: new Bools() },
      { hour: '04:30', bools: new Bools() },
      { hour: '05:00', bools: new Bools() },
      { hour: '05:30', bools: new Bools() },
      { hour: '06:00', bools: new Bools() },
      { hour: '06:30', bools: new Bools() },
      { hour: '07:00', bools: new Bools() },
      { hour: '07:30', bools: new Bools() },
      { hour: '08:00', bools: new Bools() },
      { hour: '08:30', bools: new Bools() },
      { hour: '09:00', bools: new Bools() },
      { hour: '09:30', bools: new Bools() },
      { hour: '10:00', bools: new Bools() },
      { hour: '10:30', bools: new Bools() },
      { hour: '11:00', bools: new Bools() },
      { hour: '11:30', bools: new Bools() },
      { hour: '12:00', bools: new Bools() },
      { hour: '12:30', bools: new Bools() },
      { hour: '13:00', bools: new Bools() },
      { hour: '13:30', bools: new Bools() },
      { hour: '14:00', bools: new Bools() },
      { hour: '14:30', bools: new Bools() },
      { hour: '15:00', bools: new Bools() },
      { hour: '15:30', bools: new Bools() },
      { hour: '16:00', bools: new Bools() },
      { hour: '16:30', bools: new Bools() },
      { hour: '17:00', bools: new Bools() },
      { hour: '17:30', bools: new Bools() },
      { hour: '18:00', bools: new Bools() },
      { hour: '18:30', bools: new Bools() },
      { hour: '19:00', bools: new Bools() },
      { hour: '19:30', bools: new Bools() },
      { hour: '20:00', bools: new Bools() },
      { hour: '20:30', bools: new Bools() },
      { hour: '21:00', bools: new Bools() },
      { hour: '21:30', bools: new Bools() },
      { hour: '22:00', bools: new Bools() },
      { hour: '22:30', bools: new Bools() },
      { hour: '23:00', bools: new Bools() },
      { hour: '23:30', bools: new Bools() },
      { hour: '24:00', bools: new Bools() }
    ];
    return newHours;
  }

}
